<div
    data-test="answerOptionContainer"
    class="option"
    [class.option--correct]="correct === true"
    [class.option--incorrect]="correct === false">

    <div class="flex relative" [ngSwitch]="correct">
        <app-icon class="option__icon option__icon--correct" style="font-size: 20px" icon="check-circle" *ngSwitchCase="true"></app-icon>
        <app-icon class="option__icon option__icon--incorrect" style="font-size: 20px" icon="times-circle" *ngSwitchCase="false"></app-icon>
        <span class="option__icon" *ngSwitchDefault>
            <span class="mat-radio-outer-circle"></span>
        </span>
        
        <div class="pl-2">
            <ng-content></ng-content>
        </div>
    </div>

</div>